export type WeekType = "entreprise" | "cours" | "vacances" | "libre" | "mixte";

export interface WeekTypeConfig {
  type: WeekType;
  label: string;
  icon: string;
  badgeColor: string;
  fatigueDefault: number;
  maxSportHours: number;
  recoveryPriority: boolean;
  description: string;
}

export const WEEK_TYPES: WeekTypeConfig[] = [
  {
    type: "entreprise",
    label: "Entreprise",
    icon: "💼",
    badgeColor: "bg-muted text-muted-foreground",
    fatigueDefault: 5,
    maxSportHours: 8,
    recoveryPriority: false,
    description: "Charge normale, entraînement standard",
  },
  {
    type: "cours",
    label: "Cours",
    icon: "🎓",
    badgeColor: "bg-blue-500/20 text-blue-400",
    fatigueDefault: 7,
    maxSportHours: 5,
    recoveryPriority: true,
    description: "Volume réduit, séances courtes, accent récupération",
  },
  {
    type: "vacances",
    label: "Vacances",
    icon: "🏖️",
    badgeColor: "bg-amber-500/20 text-amber-400",
    fatigueDefault: 2,
    maxSportHours: 12,
    recoveryPriority: false,
    description: "Temps libre, possibilité de surcharge contrôlée",
  },
  {
    type: "libre",
    label: "Semaine libre",
    icon: "✅",
    badgeColor: "bg-green-500/20 text-green-400",
    fatigueDefault: 3,
    maxSportHours: 10,
    recoveryPriority: false,
    description: "Liberté totale, bon potentiel d'entraînement",
  },
  {
    type: "mixte",
    label: "Mixte",
    icon: "🔀",
    badgeColor: "bg-purple-500/20 text-purple-400",
    fatigueDefault: 5,
    maxSportHours: 8,
    recoveryPriority: false,
    description: "Mélange cours/entreprise dans la même semaine",
  },
];

export function getWeekTypeConfig(type: WeekType): WeekTypeConfig {
  return WEEK_TYPES.find((wt) => wt.type === type) || WEEK_TYPES[0];
}

/** Planning cycle config (1 per user) */
export interface PlanningCycleConfig {
  user_id: string;
  enabled: boolean;
  cycle_length_weeks: number;
  pattern: WeekType[];
  start_date: string;
  timezone: string;
  updated_at: string;
}

/** Week template (blocks for a week_type) */
export interface WeekTemplate {
  id: string;
  user_id: string;
  week_type: WeekType;
  blocks: any[];
  updated_at: string;
}

/** Override for a specific calendar week */
export interface WeekOverride {
  id: string;
  user_id: string;
  week_start_date: string;
  override_blocks: any[];
  override_week_type: WeekType | null;
  reason: string | null;
  updated_at: string;
}

/** Computed week for display */
export interface ComputedWeek {
  weekStartDate: string; // ISO date (Monday)
  weekIndex: number;     // absolute index from start_date
  cyclePosition: number; // index in pattern
  weekType: WeekType;
  blocks: any[];
  isOverride: boolean;
  overrideReason?: string | null;
}
